// extracted by mini-css-extract-plugin
module.exports = {"link":"Paragraph_link__zK_hC","richtext":"Paragraph_richtext__1E1XK"};